var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-wrapper"},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon,"alt":""}}):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }